import React from 'react';
import { Panel } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PagedEntitiesList from '../../../common/components/PagedEntitiesList';
import LabelWithTooltip from '../../../common/components/LabelWithTooltip';
import ui from '../../../common/services/ui';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlignJustify, faExchange, faLink } from '@fortawesome/free-solid-svg-icons';

const renderTotalCell = (remainingTotal, row) => {
	return ui.formatAmount(remainingTotal) + (row.refundedTotal ? ` (${ui.formatAmount(row.refundedTotal)
		})` : '');
};

const renderQuantityCell = (remainingQuantity, row) => {
	return remainingQuantity + (row.refundedQuantity ? ` (${row.refundedQuantity})` : '');
};

const List = ({ isReadonly, t, ...rest }) => {
	const columns = [
		{
			header: t('PaymentHistory_Id'),
			accessor: 'id',
			sortable: true,
			cell: (id, row) => (<Link to={`/paymentHistory/${id}`} >
				{id}&nbsp;
				{row.isTransferred && <LabelWithTooltip id='transferTooltip' tooltip={t('PaymentHistory_TransferTooltip')}><FontAwesomeIcon icon={faExchange} /></LabelWithTooltip>}
				{row.paymentParentId && <LabelWithTooltip id='parentTooltip' tooltip={t('PaymentHistory_ParentTooltip')}><FontAwesomeIcon icon={faLink} /></LabelWithTooltip>}
				{row.paymentType.id == 7 && <LabelWithTooltip id='annualTooltip' tooltip={t('PaymentHistory_AnnualTooltip')}><FontAwesomeIcon icon={faAlignJustify} /></LabelWithTooltip>}
			</Link>)
		},
		{
			header: t('PaymentHistory_Parent'),
			accessor: 'parent.fullname',
			cell: (parent, row) => {
				return <Link to={`/parents/${row.parent.id}`} > {row.parent.fullname}</Link>;
			},
			sortable: true
		},
		{
			header: t('PaymentHistory_Child'),
			accessor: 'child.fullname',
			cell: (child, row) => {
				return <Link to={`/parents/${row.parent.id}/children/${row.child.id}`} >
					{row.child.fullname}
				</Link>
			},
			sortable: true
		},
		{
			header: t('PaymentHistory_Center'),
			accessor: 'center',
			sortable: true
		},
		{
			header: t('PaymentHistory_NumberOfLessons'),
			accessor: 'remainingQuantity',
			sortable: true,
			cell: renderQuantityCell
		},
		{
			header: t('PaymentHistory_Total'),
			accessor: 'remainingTotal',
			sortable: true,
			cell: renderTotalCell
		},
		{
			header: t('PaymentHistory_DiscountAmount'),
			accessor: 'discount',
			sortable: true
		},
		{
			header: t('ReportChildren_Grade'),
			accessor: 'grade',
			sortable: true
		},
		{
			header: t('ReportChildren_WeekDay'),
			accessor: 'dayOfWeek',
			cell: dayOfWeek => dayOfWeek && t(ui.days[dayOfWeek]),
			sortable: true
		},
		{
			header: t('PaymentHistory_Created'),
			accessor: 'created',
			sortable: true,
			cell: (created) => (ui.formatDateTime(created))
		},
		{
			header: t('PaymentHistory_StartDate'),
			accessor: 'startDate',
			sortable: true,
			cell: (startDate) => (ui.formatDate(startDate))
		},
		{
			header: t('PaymentHistory_StartTime'),
			accessor: 'startTime',
			sortable: true,
			cell: (startTime) => (ui.formatTime(startTime))
		},
		{
			header: t('PaymentHistory_AutomaticCancellationDate'),
			accessor: 'automaticNotApprovedCancellationDate',
			sortable: true,
			cell: (automaticNotApprovedCancellationDate) => (ui.formatDateTime(automaticNotApprovedCancellationDate))
		}
	];

	return (
		<Panel>
			<Panel.Body>
				<PagedEntitiesList columns={columns} {...rest} />
			</Panel.Body>
		</Panel>
	);
};

export default withTranslation()(List);